import { render, staticRenderFns } from "./TrainingDetail.vue?vue&type=template&id=7cb20bb8&scoped=true&"
import script from "./TrainingDetail.vue?vue&type=script&lang=ts&"
export * from "./TrainingDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingDetail.vue?vue&type=style&index=0&id=7cb20bb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb20bb8",
  null
  
)

export default component.exports